// modules/init-mobile-sliders.js

/**
 * Modulo Universale per Slider Mobile-Only (Swiper.js)
 * 
 * Trasforma griglie Bootstrap in slider su dispositivi mobile/tablet.
 * Si attiva automaticamente per elementi con l'attributo [data-mobile-slider="true"].
 * 
 * Requisiti Markup:
 * <div class="swiper" data-mobile-slider="true">
 *   <div class="swiper-wrapper row ...">
 *     <div class="swiper-slide col-..."> ... </div>
 *   </div>
 *   <div class="swiper-pagination"></div> (opzionale)
 * </div>
 */

let activeSliders = new Map();

export function initMobileSliders() {
    
    // Verifica disponibilità Swiper
    if (typeof Swiper === "undefined") {
        console.warn("Mobile Slider: Swiper non è disponibile.");
        return;
    }

    const sliderContainers = document.querySelectorAll('[data-mobile-slider="true"]');
    if (!sliderContainers.length) return;

    const enableSlider = (container) => {
        // Generiamo un ID o usiamo quello esistente per tracciare l'istanza
        const id = container.id || `slider-${Math.random().toString(36).substr(2, 9)}`;
        
        if (activeSliders.has(id)) return;

        /**
         * FIX BULLETS NOT UPDATING:
         * Invece di distruggere lo slider al resize, usiamo la proprietà 'enabled'.
         * Questo mantiene i riferimenti della paginazione intatti.
         */
        const swiperInstance = new Swiper(container, {
            slidesPerView: 1, 
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            speed: 1000,
            
            // Parametri di osservazione per gestire il passaggio Desktop/Mobile
            // observer: true,
            // observeParents: true,
            // watchSlidesProgress: true,
            // slideToClickedSlide: true, 

            pagination: {
                el: container.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // Gestione nativa Swiper per abilitare/disabilitare lo slider
            breakpoints: {
                // Sopra 992px lo slider viene disattivato ma NON distrutto
                991.98: {
                    enabled: false,
                },
                // Tablet: visualizzazione parziale per suggerire lo scroll
                768: {
                    enabled: true,
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                },
                // Mobile: slide singola
                0: {
                    enabled: true,
                    slidesPerView: 1,
                    spaceBetween: 16,
                }
            }
        });

        activeSliders.set(id, swiperInstance);
        console.log(`[MobileSlider] Inizializzato (Breakpoint Control): ${id}`);
    };

    const checkViewport = () => {
        // Ora inizializziamo tutti i contenitori una sola volta.
        // La gestione della distruzione non è più necessaria perché lo slider
        // si disabilita da solo tramite i breakpoints.
        sliderContainers.forEach((container) => {
            enableSlider(container);
        });
    };

    // Inizializzazione al caricamento
    checkViewport();

    // Reset o resize timer non sono più strettamente necessari per abilitare/disabilitare
    // ma possono aiutare Swiper a ricalcolare se il layout Bootstrap cambia drasticamente.
    window.addEventListener("resize", () => {
        activeSliders.forEach(instance => instance.update());
    });
}
